import { render, staticRenderFns } from "./ModalAdminRequestService.vue?vue&type=template&id=2035f612&scoped=true&lang=pug&"
import script from "./ModalAdminRequestService.vue?vue&type=script&lang=ts&"
export * from "./ModalAdminRequestService.vue?vue&type=script&lang=ts&"
import style0 from "./ModalAdminRequestService.vue?vue&type=style&index=0&id=2035f612&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2035f612",
  null
  
)

export default component.exports